// ============================================================
// Reports — the daily summary (sent at 16:00) and the weekly
// report for management, built from the demo history so the
// numbers match the Statistiky views. Plates and orders of the
// listed trucks are fictional and seeded, like the rest.
// ============================================================

import { history, summarize, rng } from './statsData';
import { carrierHistory, carrierScorecard } from './carrierStats';
import { carriers } from './arrivalsData';

const PLANNED_HOURS = [6, 7, 7, 8, 9, 12, 13, 13, 14, 15];

function fakePlate(r, carrier) {
  const digits = String(1000 + Math.floor(r() * 9000));
  return carrier.country === 'PL'
    ? `${['SK', 'SO', 'SOP', 'SGL'][Math.floor(r() * 4)]} ${digits}${'KMXTV'[Math.floor(r() * 5)]}`
    : `${1 + Math.floor(r() * 8)}M${Math.floor(r() * 9)} ${digits}`;
}

const fakeTruck = (r, carrier, hours) => ({
  carrier: carrier.name,
  plate: fakePlate(r, carrier),
  orderId: `DOD 8046${String(Math.floor(r() * 10000)).padStart(4, '0')}`,
  planned: `${String(hours[Math.floor(r() * hours.length)]).padStart(2, '0')}:${r() < 0.5 ? '00' : '30'}`,
});
const byTime = (a, b) => a.planned.localeCompare(b.planned);

// One line per truck that did not come, from the per-carrier split of the day.
function missingTrucks(dayIndex, r) {
  const day = carrierHistory[dayIndex];
  return carriers
    .flatMap(c => Array.from({ length: day.carriers[c.id].noShows }, () => fakeTruck(r, c, PLANNED_HOURS)))
    .sort(byTime);
}

// Afternoon loadings whose follow-up got no answer, not even after the call:
// the planner takes them over. Slow responders (D2, D5) are the usual ones.
function openTrucks(count, r) {
  const pool = ['D2', 'D2', 'D5', 'D1'].map(id => carriers.find(c => c.id === id));
  return Array.from({ length: count }, () => fakeTruck(r, pool[Math.floor(r() * pool.length)], [14, 15, 16])).sort(byTime);
}

// Daily summary for the last working day of the history.
export function dailySummary() {
  const index = history.length - 1;
  const day = history[index];
  const r = rng(1600 + index);
  const missing = missingTrucks(index, r);
  const open = openTrucks(day.urgencies - day.autoResolved, r);
  return {
    date: day.date,
    planned: day.planned,
    loaded: day.planned - day.noShows,
    noShows: day.noShows,
    informedPct: day.informedPct,
    urgencies: day.urgencies,
    autoResolved: day.autoResolved,
    missing,
    open,
  };
}

// Weekly report: the last 5 working days vs. the pre-pilot baseline, worst carriers first.
export function weeklyReport() {
  const days = 5;
  const kpis = summarize(history, days);
  const worst = carrierScorecard(days)
    .sort((a, b) => b.now.noShowPct - a.now.noShowPct)
    .slice(0, 3);
  return {
    from: history[history.length - days].date,
    to: history[history.length - 1].date,
    kpis,
    worst,
  };
}
